export default __webpack_public_path__ + "static/media/Available.f7d86848.svg";